import React, {useCallback} from 'react'
import {Dialog, Slide, SlideProps} from "@mui/material";
import Icon from "@/view/common/component/Icon";
import {BoardData} from "@/service/BoardService";
import BoardDetailView from "@/view/board/BoardDetailView";

export interface BoardItemParam{
    type:string,
    index:number,
    title:string,
    contents?:string,
    subTitle?:string,
    nickName?:string,
    heightClass:string,
    leftIcon?:string,
    rightContent?:JSX.Element,
    onReturn?:() => void,
    detailProp?: BoardData | undefined //상세페이지에서 필요한 타입이 있을경우 추가
}

const Transition = React.forwardRef(function Transition(
    props: SlideProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="left" ref={ref} {...props}/>;
});

const BoardListItem = (props: BoardItemParam) => {
    const [open, setOpen] = React.useState(false)
    const handleReturnClick = useCallback(() => {props.onReturn && props.onReturn()},  [props.onReturn])

    const handleClose = () => {
        setOpen(false);
    };

    const onClickEvent = () => {
        props.contents && setOpen(true)
    }

    return <div className={`flex ${props.index == 0 ? '' : 'border-top-gray'} ${props.heightClass}`}>
        {props.leftIcon
            ?<div className={'mr-8px pt-22px'}><Icon iconClass={props.leftIcon}/></div>
            : null
        }
        <div className={`board-item w-100p`}
             onClick={onClickEvent}>
            <div className={'board-item-title'}>
            <div className={'flex-column'}>
                <span className='b2_r'>{props.title}</span>
                {props.nickName ? <p className={'c1_r cl-gray04'}>{props.nickName}</p>:''}
                {props.subTitle ? <p className={'c1_r cl-gray04'}>{props.subTitle}</p> : ''}
            </div>
            <div className={`${props.rightContent === undefined ? '' : 'right-contents'}`}>
                {props.rightContent}
            </div>
            </div>
        </div>
        <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
            {props.type === 'boardDetail' &&
                <BoardDetailView onClose={handleClose} onReturn={handleReturnClick} board={props?.detailProp}/>}
        </Dialog>
    </div>
}

export default BoardListItem;